import ItemTileView, { ItemTileViewPropsBase } from './ItemTileView';
import { observer } from 'mobx-react';
import { Image, ImageFit } from 'office-ui-fabric-react/lib/Image';
import * as React from 'react';

const styles = require('./PhotoTileView.scss');
const classNames = require('classnames');

export interface PhotoTileViewProps extends ItemTileViewPropsBase {
    thumbnailUrl: string;
}

/**
 * As this is only a locally used state which is only required to figure
 * out if the image is loaded hence it is not in the store and limited only
 * within this component so as not to polute global file picker store
 */
export interface PhotoTileViewState {
    isImageLoaded: boolean;
}

@observer
export default class PhotoTileView extends React.Component<PhotoTileViewProps, PhotoTileViewState> {
    constructor(props: PhotoTileViewProps) {
        super(props);

        this.state = {
            isImageLoaded: false,
        };
    }

    componentsWillReceiveProps(nextProps: PhotoTileViewProps) {
        if (nextProps.thumbnailUrl !== this.props.thumbnailUrl) {
            // If the thumbnail changed then reset the state
            this.setState({ isImageLoaded: false });
        }
    }

    render() {
        const isThumbnailAvailable = this.props.thumbnailUrl ? true : false;
        const photoThumbnailOverlayStyle = this.props.isSelected
            ? styles.photoThumbnailSelectedOverlay
            : styles.photoThumbnailOverlay;

        return (
            <ItemTileView
                {...this.props as any}
                className={styles.container}
                shouldShowTileOverlay={!this.state.isImageLoaded}>
                {/* The icon for photo if there is no thumbnail */}
                {!isThumbnailAvailable && (
                    <div className={styles.photoIconContainer}>
                        <i
                            className={classNames(this.props.icon.large, styles.photoIcon)}
                            data-is-focusable={false}
                        />
                    </div>
                )}

                {/* The thumbnail is hidden while its being loaded and when successfully loaded we display it */}
                {isThumbnailAvailable && (
                    <div className={styles.photoThumbnailContainer}>
                        <Image
                            className={styles.photoThumbnail}
                            src={this.props.thumbnailUrl}
                            onLoad={this.onImageLoaded}
                            imageFit={ImageFit.cover}
                            data-is-focusable={false}
                        />

                        <div className={photoThumbnailOverlayStyle}>
                            <div className={styles.photoTileOverlay}>
                                <div className={styles.photoTilePrimaryTextOverlay}>
                                    {' '}
                                    {this.props.primaryText}{' '}
                                </div>
                                {this.props.secondaryText && (
                                    <div className={styles.photoTileSecondaryTextOverlay}>
                                        {' '}
                                        {this.props.secondaryText}{' '}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </ItemTileView>
        );
    }

    private onImageLoaded = (event: React.SyntheticEvent<HTMLImageElement>) => {
        this.setState({ isImageLoaded: true });
    };
}
